// export const capFirstLetter = (word) => {
//   // capitalize the first letter
//   let wordLowerCase = word.toLowerCase();
//   let result = wordLowerCase.charAt(0).toUpperCase() + wordLowerCase.slice(1);
//   return result;
// };

export const capFirstLetter = (word) => {
  if (!word || typeof word !== 'string') return '';
  const trimmed = word.trim().toLowerCase();
  return trimmed.charAt(0).toUpperCase() + trimmed.slice(1);
};
